import { checkoutOrder } from './checkout-order-en.i18n';

export const en = {
  checkoutOrder,
};
